function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 5.667c-1.43 0-2.589 1.194-2.589 2.667C5.411 9.806 6.57 11 8 11s2.589-1.194 2.589-2.666C10.589 6.86 9.43 5.667 8 5.667m0 1.5c.6 0 1.089.523 1.089 1.167C9.089 8.977 8.6 9.5 8 9.5s-1.089-.523-1.089-1.166c0-.644.489-1.167 1.089-1.167",
  fill: "#000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 3C4.453 3 1.426 6.207.245 7.647a1.083 1.083 0 000 1.373C1.426 10.46 4.453 13.667 8 13.667c3.548 0 6.574-3.207 7.755-4.647a1.083 1.083 0 000-1.373C14.574 6.207 11.548 3 8 3m0 1.5c2.767 0 5.364 2.663 6.372 3.833-1.008 1.17-3.605 3.834-6.372 3.834S2.636 9.504 1.627 8.333C2.635 7.163 5.233 4.5 8 4.5",
  fill: "#000",
  fillRule: "nonzero"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), _ref);
};

export default SvgComponent;